// DOIT rester le premier import : wrappe window.fetch avant que le client
// supabase (créé à l'import) ne capture le fetch global (TICKET-CRM-14).
import './lib/feedback/install-network-tracker';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
